export default __webpack_public_path__ + "static/media/2025_D4URC_Dealer_Portal_Login_Page_66800.ab7b7658.png";